import { RootState } from '../store';

// Constant empty array to maintain referential equality
const EMPTY_UPLOADS: any[] = [];

export const selectUploads = (state: RootState) => state.uploads.uploads;
export const selectUploadsByListingId = (state: RootState, id: string) =>
  state.uploads.uploads[id] ?? EMPTY_UPLOADS;
